module.exports = __webpack_public_path__ + "static/media/spada-traders-latest.cd2546dd.png";